/**
 *
 * AccountExtraInfoModal
 *
 */

import React from 'react';
import { useSelector } from 'react-redux';
import Modal from '@material-ui/core/Modal';
import ThemedDialog from 'components/ThemedDialog';
import _get from 'lodash/get';
import { makeSelectProfile } from 'containers/Auth/selectors';
import {
  makeSelectClientDetails,
  makeSelectFirestoreStatus,
  makeSelectInsuranceModal,
  makeSelectPersonalEmailModal,
} from 'containers/Main/selectors';
import InsuranceContent from './components/InsuranceContent';
import PersonalEmailContent from './components/PersonalEmailContent';

function AccountExtraInfoModal() {
  const profile = useSelector(makeSelectProfile());
  const firestoreStatus = useSelector(makeSelectFirestoreStatus());
  const personalEmailStatus = useSelector(makeSelectPersonalEmailModal());
  const insuranceStatus = useSelector(makeSelectInsuranceModal());
  const clientDetails = useSelector(makeSelectClientDetails());

  const personalEmailVisibility =
    firestoreStatus &&
    !profile.isEmpty &&
    !profile.personalEmail &&
    personalEmailStatus.visible;
  const insuranceVisibility = insuranceStatus.visible;
  const open = personalEmailVisibility || !!insuranceVisibility;

  const shouldUseThemedDialog = _get(
    clientDetails,
    'metadata.useThemedDialogOnAuthModal',
    false,
  );

  const DialogComponent = shouldUseThemedDialog ? ThemedDialog : Modal;

  return (
    <DialogComponent open={!!open} maxWidth={false} showCloseButton={false}>
      <div>
        {personalEmailVisibility && (
          <PersonalEmailContent
            type={personalEmailStatus.type}
            shouldUseThemedDialog={shouldUseThemedDialog}
            isOpen={!!open}
          />
        )}
        {!personalEmailVisibility && insuranceVisibility && (
          <InsuranceContent />
        )}
      </div>
    </DialogComponent>
  );
}

export default AccountExtraInfoModal;
